<!--
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-15 16:36:38
-->
<template>
  <div
    :class="['s-select-option',{selected: isSelected}]"
    :style="{height: height+ 'px'}"
    @click="select"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'SSelectOption',
  mounted () {
    setTimeout(() => {
      this.height = this.$parent.$refs.select.clientHeight
    }, 500)
  },
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      height: 0
    }
  },
  computed: {
    isSelected () {
      return this.value === this.$parent.value && !this.$parent.mouseenter
    }
  },
  methods: {
    select () {
      console.log(this.value)
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="less" scoped>
  .s-select-option {
      width: 100%;
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 15px;
      font-size: 16px;
      color: #333;
      &:not(:last-child) {
        border-bottom: solid 1px #595956;
      }
    &.selected {
      background: #fff1c2;
      color: #3c120a;
    }
    &:hover {
      background: #fff1c2;
      color: #3c120a;
    }
  }
  @media screen and (max-width: 750px) {
    .s-select-option {
      // padding-left: 4.266667rem /* 32/7.5 */;
      // font-size: 4.666667rem /* 35/7.5 */;
      font-size: 2.6667rem /* 20/7.5 */;
    }
  }
</style>
